// VideoPlayer class for managing all player functionality
export class VideoPlayer {
  constructor(config) {
    this.config = config;
    this.video = null;
    this.controller = null;
  }

  initialize() {
    this.video = document.querySelector('bunny-stream-video') ||
      document.querySelector('video');
    this.controller = document.querySelector('media-controller');

    if (!this.video || !this.controller) {
      console.error('Required video or media-controller elements not found');
      return;
    }

    // Apply initial configurations
    this.applyInitialConfigurations();

    // Setup all features
    this.setupStartTime();
    this.setupRememberPosition();
    this.setupViewTracking();
    // Heatmap is injected via template attributes; no JS wiring needed
    this.setupAirPlay();
    this.setupiOS();
    this.setupChromecast();
    this.setupLevelCap();

    this.video.addEventListener('loadeddata', () => {
      // Get the actual video element from the bunny-stream-video component
      const actualVideo = this.video.querySelector('video') ||
        this.video.shadowRoot?.querySelector('video');
      if (actualVideo) {
        if (!actualVideo.on) {
          actualVideo.on = (event, callback) => {
            actualVideo.addEventListener(event, callback);
          };
        }
        if (!actualVideo.off) {
          actualVideo.off = (event, callback) => {
            actualVideo.removeEventListener(event, callback);
          };
        }
        if (!actualVideo.trigger) {
          actualVideo.trigger = (event, data) => {
            actualVideo.dispatchEvent(new CustomEvent(event, { detail: data }));
          };
        }
      }
      const pjs = new BunnyPlayerJs(actualVideo || this.video);
      pjs.init();
    });
  }

  applyInitialConfigurations() {
    // Apply configurations that need to be set immediately
    if (this.config.config.disableAirPlay) {
      this.video.disableRemotePlayback = true;
    }
    if (this.config.config.disableIosPlayer) {
      this.video.setAttribute('webkit-playsinline', '');
    }
    if (this.config.config.levelCap && globalThis.Hls) {
      const hls = new globalThis.Hls();
      hls.capLevelToPlayerSize = true;
    }
  }

  setupStartTime() {
    const startTime = this.config.startTime;
    if (startTime > 0) {
      const seekToStartTime = () => {
        this.video.currentTime = startTime;
        this.video.removeEventListener('loadedmetadata', seekToStartTime);
      };

      if (this.video.readyState >= 1) {
        seekToStartTime();
      } else {
        this.video.addEventListener('loadedmetadata', seekToStartTime);
      }
    }
  }

  setupRememberPosition() {
    const rememberPos = this.config.config.rememberPosition !== null
      ? this.config.config.rememberPosition
      : this.config.videoData.rememberPlayerPosition;
    if (rememberPos) {
      const positionKey =
        `bunny_player_position_${this.config.videoData.video.guid}`;
      const lastPosition = localStorage.getItem(positionKey);
      if (lastPosition) {
        this.video.currentTime = parseFloat(lastPosition);
      }

      this.video.addEventListener('timeupdate', () => {
        localStorage.setItem(positionKey, this.video.currentTime.toString());
      });

      this.video.addEventListener('ended', () => {
        localStorage.removeItem(positionKey);
      });
    }
  }

  setupViewTracking() {
    if (!this.config.config.trackView) return;

    let viewTracked = false;
    const trackView = () => {
      if (viewTracked || this.video.currentTime < 5) return;
      viewTracked = true;
      console.log(
        'View tracked for video:',
        this.config.videoData.video.guid,
      );
      this.video.removeEventListener('timeupdate', trackView);
    };

    this.video.addEventListener('timeupdate', trackView);
  }

  // heatmap handled declaratively via template attributes

  setupAirPlay() {
    if (this.config.config.disableAirPlay) {
      this.video.disableRemotePlayback = true;
    }
  }

  setupiOS() {
    if (this.config.config.disableIosPlayer) {
      this.video.setAttribute('webkit-playsinline', '');
    }
  }

  setupChromecast() {
    if (this.config.config.chromecast) {
      console.log(
        'Chromecast support enabled for video:',
        this.config.videoData.video.guid,
      );
    }
  }

  setupLevelCap() {
    if (this.config.config.levelCap && globalThis.Hls) {
      // HLS.js level cap configuration
      const hls = new globalThis.Hls();
      hls.capLevelToPlayerSize = true;
    }
  }
}
